import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: [
      'League Spartan',
      'Segoe UI',
      'Tahoma',
      'Geneva',
      'Verdana',
      'sans-serif',
    ].join(','),
    h1: {
      fontFamily: 'League Spartan',
      fontWeight: 700,
      letterSpacing: '0.01em',
      lineHeight: 1.2,
    },
    h2: {
      fontFamily: 'League Spartan',
      fontWeight: 700,
      letterSpacing: '0.01em',
      lineHeight: 1.2,
    },
    h3: {
      fontFamily: 'League Spartan',
      fontWeight: 700,
      letterSpacing: '0.01em',
      lineHeight: 1.2,
    },
    h4: {
      fontFamily: 'League Spartan',
      fontWeight: 700,
      letterSpacing: '0.01em',
      lineHeight: 1.2,
    },
    h5: {
      fontFamily: 'League Spartan',
      fontWeight: 700,
      letterSpacing: '0.01em',
      lineHeight: 1.2,
    },
    h6: {
      fontFamily: 'League Spartan',
      fontWeight: 700,
      letterSpacing: '0.01em',
      lineHeight: 1.2,
    },
    button: {
      fontFamily: 'League Spartan',
      fontWeight: 500,
      letterSpacing: '0.01em',
    },
    body1: {
      fontFamily: 'League Spartan',
      fontWeight: 400,
      letterSpacing: '0.01em',
      lineHeight: 1.6,
    },
    body2: {
      fontFamily: 'League Spartan',
      fontWeight: 400,
      letterSpacing: '0.01em',
      lineHeight: 1.6,
    },
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          '&[dir="rtl"]': {
            fontFamily: 'Readex Pro, Noto Sans Arabic, sans-serif',
            fontWeight: 400,
            letterSpacing: '0.02em',
            lineHeight: 1.8,
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          '&[dir="rtl"]': {
            fontFamily: 'Readex Pro, Noto Sans Arabic, sans-serif',
            fontWeight: 500,
            letterSpacing: '0.02em',
          },
        },
      },
    },
  },
});

export default theme;
